import React, { useState } from "react";
import { toast } from "sonner";
import { ArrowRight, Linkedin, Mail } from "lucide-react";
import Logo from "./Logo";

const navLinks = [
  { href: "/#inicio", label: "Inicio" },
  { href: "/#nosotros", label: "Nosotros" },
  { href: "/#servicios", label: "Servicios" },
  { href: "/#productos", label: "Productos" },
  { href: "/#sectores", label: "Sectores" },
  { href: "/#ventajas", label: "Ventajas" },
  { href: "/#proceso", label: "Cómo Trabajamos" },
  { href: "/#faq", label: "FAQ" },
  { href: "/#contacto", label: "Contacto" },
];

export const Footer = () => {
  const [email, setEmail] = useState("");
  const year = new Date().getFullYear();

  const subscribe = (e) => {
    e.preventDefault();
    if (!email || !email.includes("@")) {
      toast.error("Introduce un email válido.");
      return;
    }
    toast.success("¡Suscripción registrada! Te informaremos de novedades.");
    setEmail("");
  };

  return (
    <footer
      data-testid="footer"
      className="relative bg-[#050B14] border-t border-white/5 text-slate-300"
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16 grid lg:grid-cols-12 gap-10">
        <div className="lg:col-span-4">
          <Logo />
          <p className="mt-5 text-slate-400 text-sm leading-relaxed max-w-xs">
            Extractores autorizados RETEF. Liberamos la liquidez retenida por
            los impuestos especiales sobre alcohol, bebidas derivadas e
            hidrocarburos.
          </p>
          <div className="mt-6 flex items-center gap-3">
            <a
              href="https://linkedin.com"
              target="_blank"
              rel="noopener noreferrer"
              data-testid="footer-linkedin"
              className="w-10 h-10 rounded-lg bg-white/5 border border-white/10 flex items-center justify-center hover:bg-[#0066FF] hover:border-[#0066FF] transition-all"
              aria-label="LinkedIn"
            >
              <Linkedin className="w-4 h-4" />
            </a>
            <a
              href="mailto:info@fiscalbond.es"
              data-testid="footer-email"
              className="w-10 h-10 rounded-lg bg-white/5 border border-white/10 flex items-center justify-center hover:bg-[#FF6B00] hover:border-[#FF6B00] transition-all"
              aria-label="Email"
            >
              <Mail className="w-4 h-4" />
            </a>
          </div>

          <div
            data-testid="footer-legal-id"
            className="mt-6 p-4 rounded-xl bg-white/5 border border-white/10 text-[11px] leading-relaxed text-slate-400"
          >
            <span className="text-white font-semibold">FiscalBond</span>
            <span className="text-slate-500"> · </span>CIF: B-13521570
            <span className="text-slate-500"> · </span>Inscrita en el Registro de Extractores de Depósitos Fiscales (REDEF) concedido por la AEAT
            <span className="text-slate-500"> · </span>
            <span className="text-[#FF6B00] font-mono">Nº Registro REDEF: 004VBSG6OC001684166</span>
            <span className="text-slate-500"> · </span>Real Decreto 249/2023
          </div>
        </div>

        <div className="lg:col-span-3">
          <h4 className="text-white font-semibold mb-4 uppercase text-xs tracking-[0.2em]" style={{ fontFamily: "Poppins" }}>
            Navegación
          </h4>
          <ul className="space-y-2 text-sm">
            {navLinks.map((l) => (
              <li key={l.href}>
                <a
                  href={l.href}
                  data-testid={`footer-link-${l.label.toLowerCase().replace(/\s+/g, "-")}`}
                  className="hover:text-[#0066FF] transition-colors"
                >
                  {l.label}
                </a>
              </li>
            ))}
          </ul>
        </div>

        <div className="lg:col-span-5">
          <h4 className="text-white font-semibold mb-4 uppercase text-xs tracking-[0.2em]" style={{ fontFamily: "Poppins" }}>
            Newsletter
          </h4>
          <p className="text-sm text-slate-400 mb-4 max-w-md">
            Suscríbete para recibir novedades sobre impuestos especiales,
            régimen suspensivo y gestión de depósitos fiscales.
          </p>
          <form onSubmit={subscribe} className="flex gap-2" data-testid="newsletter-form">
            <input
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              placeholder="tu@empresa.es"
              data-testid="newsletter-email-input"
              className="flex-1 bg-white/5 border border-white/10 rounded-xl px-4 py-3 text-sm text-white placeholder-slate-500 focus:outline-none focus:border-[#0066FF] transition-colors"
            />
            <button
              type="submit"
              data-testid="newsletter-submit"
              className="bg-[#0066FF] hover:bg-[#0052CC] text-white px-5 rounded-xl transition-colors inline-flex items-center gap-2"
            >
              <span className="hidden sm:inline text-sm font-medium">Suscribirme</span>
              <ArrowRight className="w-4 h-4" />
            </button>
          </form>

          <div className="mt-8 text-xs text-slate-500 leading-relaxed">
            <p id="aviso-legal" className="mb-3">
              <strong className="text-slate-400">Aviso legal · </strong>
              <span className="text-slate-300">Denominación social:</span> FiscalBond
              <span className="text-slate-600"> · </span>
              <span className="text-slate-300">CIF:</span> B-13521570
              <span className="text-slate-600"> · </span>
              <span className="text-slate-300">Domicilio:</span> Madrid, España
              <span className="text-slate-600"> · </span>
              <span className="text-slate-300">Email:</span> <a href="mailto:info@fiscalbond.es" className="hover:text-[#0066FF]">info@fiscalbond.es</a>
              <span className="text-slate-600"> · </span>
              <span className="text-slate-300">Teléfono:</span> 926 032 626 / 633 089 026.
              {" "}Inscrita en el Registro de Extractores de Depósitos Fiscales (REDEF) bajo el nº <span className="text-[#FF6B00] font-mono">004VBSG6OC001684166</span>, concedido por la AEAT según Real Decreto 249/2023. La operativa se desarrolla conforme a la Ley 38/1992 de Impuestos Especiales y al Reglamento aprobado por RD 1165/1995.
            </p>
            <p>
              <strong className="text-slate-400">Política de privacidad:</strong> Tratamos tus datos conforme al RGPD (UE) 2016/679. Los datos enviados se usan únicamente para responder a tu consulta. Puedes ejercer derechos de acceso, rectificación y supresión escribiendo a info@fiscalbond.es.
            </p>
          </div>
        </div>
      </div>

      <div className="border-t border-white/5">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-5 flex flex-col md:flex-row items-center justify-between gap-3 text-xs text-slate-500">
          <span>© {year} FiscalBond. Todos los derechos reservados.</span>
          <span className="flex items-center gap-4">
            <a href="/aviso-legal" data-testid="footer-aviso-legal" className="hover:text-[#0066FF]">Aviso legal</a>
            <a href="/politica-privacidad" data-testid="footer-politica-privacidad" className="hover:text-[#0066FF]">Política de privacidad</a>
            <a href="#aviso-legal" className="hover:text-[#0066FF]">Cookies</a>
          </span>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
